import {
  Container,
  ContainerFluid,
  Htag,
  HtagAlign,
  HtagColor,
  HtagVariant,
  PostPreviewList,
  TabsList,
} from '../../components';
import LogisticExpertise from './logistic-expertise';
import LogisticIntro from './logistic-intro';
import LogisticService from './logistic-service';
import LogisticSoftware from './logistic-software';
import styles from './logistic.module.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import LogisticDelivered from './logistic-delivered';
import { IArticles } from '../blog/blog.types';
import tabs from '../../utils/tabs';
import LogisticConsultation from './logistic-consultation';
import LogisticAsk from './logistic-ask';
import LogisticQuestion from './logistic-questions';
import LogisticWorld from './logistic-world';
import LogisticContact from './logistic-contact';

export interface LogisticPageProps extends Record<string, unknown> {
  posts: IArticles;
}

export default function LogisticPage({ posts }: LogisticPageProps) {
  return (
    <div className={styles.root}>
      <ContainerFluid>
        <LogisticIntro />
        <LogisticService />
        <LogisticSoftware />
        <LogisticExpertise />
        <LogisticAsk
          text=" Ask our managers all you want to know about Logistics and SCM software development, and they’ll answer within 24 hours. It’s free of charge and commitment."
          title="Got any questions to ask?"
        />
        <LogisticDelivered />
        <section className={styles.tabs}>
          <Container>
            <Htag
              tag="h2"
              color={HtagColor.light}
              align={HtagAlign.center}
              className={styles.tabs__title}
              variant={HtagVariant.h2}
            >
              our services
            </Htag>
            <TabsList tabs={tabs} />
          </Container>
        </section>
        <LogisticAsk
          text="Contact our managers to get answers to all your questions about logistics software development."
          title="Got any questions to ask?"
        />
        <LogisticConsultation />
        <LogisticQuestion />
        <LogisticWorld />
        <section>
          <Container>
            <PostPreviewList posts={posts} />
          </Container>
        </section>
        <LogisticContact />
      </ContainerFluid>
    </div>
  );
}
